import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/svg/continent-1.svg")